import React, { useState } from 'react'
// import storiesDOK from '../../testing/exercise/storiesDOK'
import { Stories } from '@stem-sims/great-leaps-react-common'
import axios from 'axios'
import getURLParameters from '../../helpers/getURLParams'
import BeatLoader from "react-spinners/BeatLoader"
import { Link } from 'react-router-dom'
import buildQuery from '../../helpers/buildQuery'

class StoriesDOK extends React.Component
{
    state = {
        levels: [],
        story: { responses : [] }
    }
    componentDidMount()
    {
        var params = getURLParameters()
        axios.get('/api/dok', {
            params: {
                type: this.props.type,
                number : this.props.match.params.probeNumber
            }})
        .then((response) =>
        {
            this.setState({levels: response.data})
        })
    
        axios.get('/api/probe', {
            params: {
                type: this.props.type,
                number: this.props.match.params.probeNumber,
                customerUsername: params.customer,
                studentName: params.student
            }
        })
        .then((response) =>
        {
            this.setState({story: response.data})
        })
    }

    render()
    {
        var { type } = this.props
        var { levels, story } = this.state
        var params = getURLParameters()
        const standardVariables = buildQuery({ student: params.student, customer: params.customer })
        return (
            <React.Fragment>
                <div class = "subheader-text">
                    <h2>Depth of Knowledge Questions</h2>
                    
                    <div class = "text-left">
                        {levels.length == 0 ?
                            <div style={{ margin: "0 auto", display: "table", height: "40vh"}}>
                                <div style={{ display: "table-cell", verticalAlign: "middle", textAlign: "center"}}>
                                    <BeatLoader
                                        size={15}
                                        color={"#123abc"}
                                        loading={true}
                                        />
                                </div>
                            </div>
                                :
                                    levels.map((level) =>
                                    {
                                        return (
                                                <React.Fragment>
                                                    <h3>Level {level.level}</h3>
                                                    <ol>
                                                        {level.questions.map((question) =>
                                                        {
                                                            return <li>{question.question}</li>
                                                        })}
                                                    </ol>
                                                </React.Fragment>)
                                    })
                                }
                    </div>
                    
                    <div class = "row">
                        <button type = "button" class = "btn btn-info float-left" data-toggle = "collapse" data-target = "#story-review">
                            <i class = "fas fa-info" style = {{"padding-right": "10px" }}></i>
                            Review Exercise
                        </button>
                    </div>
                    <div class = "row">
                        <div id = "story-review" class = "collapse">
                            <div class = "card-body text-justify">
                                <Stories exerciseNumber = {this.props.match.params.probeNumber} title = {story.title} responses = {story.responses} indentedParagraphs = {story.indentedParagraphs} hideGhosting = {true} />
                            </div>
                        </div>
                    </div>
    
                    <div class = "subheader-text row">
                            <div class = "col-sm-6">
                                <Link to = {`/students/records/stories/${type}?${standardVariables}`} target = "_blank" class = "btn btn-secondary btn-lg">View Student's Records</Link>
                            </div>
                            
                            <div class = "col-sm-6">
                                <Link to = "/dashboard" class = "btn btn-secondary btn-lg">Next Student</Link>
                            </div>
                        </div>
                </div>
            </React.Fragment>
    
        )
    }
}

export default StoriesDOK
